import { NavItemModel } from '../../common';

export const footerFaqContentIds: Record<'anonymous' | 'authenticated' | 'bmi', string> = {
  anonymous: '2037',
  authenticated: '2057',
  bmi: '3452',
};

export const FOOTER_IMPRINT_ROUTE_NAME: string = 'impressum';
export const FOOTER_IMPRINT_ROUTE_PATH: string = 'impressum';
export const footerImprintNavItem: NavItemModel = {
  name: FOOTER_IMPRINT_ROUTE_NAME,
  url: `/${FOOTER_IMPRINT_ROUTE_PATH}`,
  type: 'content',
  label: 'Impressum',
  id: '1795',
};

export const FOOTER_GENERAL_TERMS_AND_CONDITIONS_ROUTE_NAME: string = 'agb';
export const FOOTER_GENERAL_TERMS_AND_CONDITIONS_ROUTE_PATH: string = 'agb';
export const footerGeneralTermsAndConditionsNavItem: NavItemModel = {
  name: FOOTER_GENERAL_TERMS_AND_CONDITIONS_ROUTE_NAME,
  url: `/${FOOTER_GENERAL_TERMS_AND_CONDITIONS_ROUTE_PATH}`,
  type: 'content',
  label: 'AGB',
  id: '1804',
};

export const FOOTER_PRIVACY_ROUTE_NAME: string = 'datenschutz';
export const FOOTER_PRIVACY_ROUTE_PATH: string = 'datenschutz';
export const footerPrivacyNavItem: NavItemModel = {
  name: FOOTER_PRIVACY_ROUTE_NAME,
  url: `/${FOOTER_PRIVACY_ROUTE_PATH}`,
  type: 'content',
  label: 'Datenschutz',
  id: '1833',
};

export const FOOTER_DPG_CONDITIONS_ROUTE_NAME: string = 'dpg-bedingungen';
export const FOOTER_DPG_CONDITIONS_ROUTE_PATH: string = 'dpg-bedingungen';
export const footerDpgConditionsNavItem: NavItemModel = {
  name: FOOTER_DPG_CONDITIONS_ROUTE_NAME,
  url: `/${FOOTER_DPG_CONDITIONS_ROUTE_PATH}`,
  type: 'content',
  label: 'DPG Bedingungen',
  id: '4614',
};

export const FOOTER_FAQ_ROUTE_NAME: string = 'hilfe-und-faq';
export const FOOTER_FAQ_ROUTE_PATH: string = 'hilfe-und-faq';
export const footerFaqNavItem: NavItemModel = {
  name: FOOTER_FAQ_ROUTE_NAME,
  url: `/${FOOTER_FAQ_ROUTE_PATH}`,
  type: 'content',
  label: 'Hilfe & FAQ',
};

export const FOOTER_HOLIDAYS_ROUTE_NAME: string = 'feiertagskalender';
export const FOOTER_HOLIDAYS_ROUTE_PATH: string = 'feiertagskalender';
export const footerHolidaysNavItem: NavItemModel = {
  name: FOOTER_HOLIDAYS_ROUTE_NAME,
  url: `/${FOOTER_HOLIDAYS_ROUTE_PATH}`,
  type: 'content',
  label: 'Feiertagskalender',
  id: '3453',
};

export const FOOTER_ACCOUNT_DELETE_ROUTE_NAME: string = 'account-delete';
export const FOOTER_ACCOUNT_DELETE_ROUTE_PATH: string = 'account/delete';
export const footerAccountDeleteNavItem: NavItemModel = {
  name: FOOTER_ACCOUNT_DELETE_ROUTE_NAME,
  url: `/${FOOTER_ACCOUNT_DELETE_ROUTE_PATH}`,
  label: 'Account löschen',
};

export const FOOTER_TOS_ROUTE_NAME: string = 'Nutzungsbedinungen';
export const FOOTER_TOS_ROUTE_PATH: string = 'https://id.lekkerland.io/tos/6704dc24-a2cb-4fa3-b9dd-2d7b46e16268';
export const footerTosNavItem: NavItemModel = {
  name: FOOTER_TOS_ROUTE_NAME,
  url: `${FOOTER_TOS_ROUTE_PATH}`,
  target: '_blank',
  label: 'Nutzungsbedingungen',
};

export const NOT_FOUND_ROUTE_NAME: string = '404';
export const NOT_FOUND_ROUTE_PATH: string = '404';
export const notFoundNavItem: NavItemModel = {
  name: NOT_FOUND_ROUTE_NAME,
  url: `/${NOT_FOUND_ROUTE_PATH}`,
  type: 'content',
  label: 'Seite nicht Gefunden',
  id: '3488',
};

export const footerNavigationItemsBase: NavItemModel[] = [
  footerImprintNavItem,
  footerGeneralTermsAndConditionsNavItem,
  footerPrivacyNavItem,
  footerDpgConditionsNavItem,
  footerHolidaysNavItem,
  footerAccountDeleteNavItem,
  footerTosNavItem,
  notFoundNavItem,
];
